import { PrecertFormField } from "src/pages/precert/types"


function makeStringLowerCase(data_array: string[]){
  data_array.forEach((ele, index, data_array) => {
    if (typeof ele === 'string') {
      data_array[index] = ele.toLowerCase()
    }
  })
  return data_array
}

const should_render_on_false = (value: string): boolean => {
  return value && ['false', 'no'].includes(value) ? true : false;
}

const should_render_on_true = (value: string, answers: string[]): boolean => {
  var lower_case_value = makeStringLowerCase(answers)
  return value && (value !== '' && value !== "false" && value !== 'no') && lower_case_value.includes(value.toLowerCase()) ? true : false
}

const should_render_from_answers = (value: string, answers: string[], answerIndex: number): boolean => {
  return answerIndex > -1 && answers.indexOf(value) === answerIndex;
}

const renderable = (condition: string, value: string, answers: string[], answerIndex: number): boolean => {
  if (condition === 'false' && should_render_on_false(value)) return false;
  if (condition === 'true' && should_render_on_true(value, answers)) return false;
  if (should_render_from_answers(value, answers, answerIndex)) return false;

  return true;
}

const renderBasedOn = (field: PrecertFormField, parent: PrecertFormField, value: string): boolean => {
  if (field.render_condition === "") return true;

  const allAnswers = parent.answers?.split(",").map((ans) => ans.trim().toLowerCase());
  const condition = field.render_condition.toString().toLowerCase();
  const answerIndex = (Number(condition) || 0) - 1

  return renderable(condition, value, allAnswers || [], answerIndex);
}



export const shouldFieldRender = (field: PrecertFormField, allFields: { [key: string]: { [key: number]: PrecertFormField } }, value: string): { [key: string]: { [key: number]: PrecertFormField } } => {
  if (!field.child_id) return allFields;

  field.child_id.forEach((fieldId: { id: number, group: string }) => {
    allFields[field.group][fieldId.id].isHidden = renderBasedOn(allFields[fieldId.group][fieldId.id], field, value);
  })

  return allFields;
}



export const updateFieldAccordingly = (field: PrecertFormField, allFields: PrecertFormField[]): PrecertFormField[] | undefined => {
  const selectedFieldIndex = allFields.findIndex((item) => field.id === item.id)
  allFields[selectedFieldIndex].isHidden = false;
  if (field.render_condition === "") return allFields;
  if (!field.parent_id) return allFields;

  const parentFieldIndex = allFields.findIndex((item) => field.parent_id === item.id)
  if (parentFieldIndex < 0) return allFields;
  if (!allFields[parentFieldIndex]) return allFields;

  allFields[selectedFieldIndex].isHidden = renderBasedOn(allFields[selectedFieldIndex], allFields[parentFieldIndex], allFields[parentFieldIndex].value as string);
  if (!Object.hasOwn(allFields[parentFieldIndex], "child_id")) allFields[parentFieldIndex].child_id = [];
  allFields[parentFieldIndex].child_id.push({ id: allFields[selectedFieldIndex].id, group: allFields[selectedFieldIndex].group });

  return allFields;
}
